import Icon from '@ant-design/icons';
import { IconProps } from '../../core/type'
import { useNavigate } from 'react-router-dom';

export const XIcon = ({ src, alt, size, style, href }: XIconProps) => {
  const navigate = useNavigate()
  return <Icon component={ () => <img src={ src } alt={ alt } style={ { width: size || 16, ...style } }/> } onClick={ () => {
    if (href) {
      navigate(href)
    }
  } }/>
}

export type XIconProps = {
  src: string | undefined;
  alt: string | undefined;
  size?: number
  href?: string
} & IconProps
